var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg097Scan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 56 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "096---Virus-Scan",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51 30v9.68c-.0005183.7300401-.2011183 1.4459747-.58 2.07-2.06 3.4-9.64 14.33-23.63 17.17-.2594892.0562764-.5244967.0831126-.79.0802427v-29.0002427z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48 30v9.68c-.0005183.7300401-.2011183 1.4459747-.58 2.07-1.948 3.216-8.843 13.157-21.42 16.629v.6212427c.2655033.0028699.5305108-.0239663.79-.0802427 13.99-2.84 21.57-13.77 23.63-17.17.3788817-.6240253.5794817-1.3399599.58-2.07v-9.68z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51 14.32.0000154 15.68h-25.0000154v-29h8.3c.6699008.01057869 1.2928108.34627871 1.67.9 3.93 5.62 11.09 9.32 13.87 10.61.7090574.3226098 1.1630578 1.031007 1.16 1.81z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49.84 12.51c-2.78-1.29-9.94-4.99-13.87-10.61-.3771892-.55372129-1.0000992-.88942131-1.67-.9h-3c.6699008.01057869 1.2928108.34627871 1.67.9 3.93 5.62 11.09 9.32 13.87 10.61.7090574.3226098 1.1630578 1.031007 1.16 1.81v15.68h3.0000154l-.0000154-15.68c.0030578-.778993-.4509426-1.4873902-1.16-1.81z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 30v29.0002427c-.2655033.0028699-.5305108-.0239663-.79-.0802427-13.99-2.84-21.57-13.77-23.63-17.17-.37888169-.6240253-.57948172-1.3399599-.58-2.07v-9.68z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 1v29h-25.00001535l.00001535-15.68c-.00305785-.778993.45094256-1.4873902 1.16-1.81 2.78-1.29 9.94-4.99 13.87-10.61.3771892-.55372129 1.0000992-.88942131 1.67-.9z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m23 1h3v29h-3z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38,
    cy: 42,
    fill: "#ffe7e8",
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 25c-.506 0-1.005.032-1.5.076 8.7736376.7696911 15.5042963 8.1166655 15.5042963 16.924s-6.7306587 16.1543089-15.5042963 16.924c.495.044.994.076 1.5.076 9.3888407 0 17-7.6111593 17-17s-7.6111593-17-17-17z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38,
    cy: 42,
    fill: "#ffe7e8",
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38,
    cy: 42,
    fill: "#ffe0e2",
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27,
    cy: 42,
    fill: "#ffe0e2",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 52,
    fill: "#ffe0e2",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25.21 58.92c.5212331.1069888 1.0587669.1069888 1.58 0 .244-.05.471-.119.711-.174-13.528-3.062-20.9-13.655-22.921-17-.37817843-.6228637-.57875145-1.3373186-.58-2.066v-25.36c-.00305785-.778993.45094256-1.4873902 1.16-1.81 2.78-1.29 9.94-4.99 13.87-10.61.3771892-.55372129 1.0000992-.88942131 1.67-.9h-3c-.6699008.01057869-1.2928108.34627871-1.67.9-3.93 5.62-11.09 9.32-13.87 10.61-.70905744.3226098-1.16305785 1.031007-1.16 1.81v25.36c.00051828.7300401.20111831 1.4459747.58 2.07 2.06 3.4 9.64 14.33 23.63 17.17z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 14.32h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff414c"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 18.32,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52 14.32c.0036885-1.1691801-.6762278-2.232649-1.739-2.72-2.8-1.3-9.71-4.9-13.475-10.28-.5659191-.81672296-1.4924344-1.30867794-2.486-1.32h-16.6c-.9957892.0124524-1.9236719.50714917-2.489 1.327-3.762 5.378-10.675 8.978-13.462 10.273-1.06615942.4849952-1.75014515 1.5487123-1.749 2.72 0 .5522847.44771525 1 1 1s1-.4477153 1-1c.00010801-.3880688.22738797-.7401376.581-.9 2.944-1.369 10.229-5.17 14.266-10.942.1888753-.28943266.5075363-.46800235.853-.478h7.3v3c0 .55228475.4477153 1 1 1s1-.44771525 1-1v-3h7.3c.3438255.00939444.6612974.1864317.85.474 4.04 5.776 11.325 9.577 14.279 10.947.3500528.1624144.5731845.5141106.571.9v14.3c-6.4448029-5.8303216-16.1479956-6.1838553-23-.838v-12.783c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v14h-11c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9.784c-5.4747174 7.0214871-4.9565634 16.9993598 1.216 23.416v3.423c-13.332-2.892-20.633-13.419-22.563-16.606-.28473826-.4680532-.43587016-1.005142-.437-1.553v-8.68h2c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-2v-6.68c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1v17.36c.00119337.9126322.25189972 1.8075674.725 2.588 2.057 3.4 9.89 14.71 24.258 17.626.3338267.0741351.6750606.1097013 1.017.106.3314019.0043115.662212-.0292392.986-.1 1.4699997-.2952933 2.9167608-.6963358 4.329-1.2 7.5973825 3.056155 16.3001054.5918947 21.1673236-5.9937329 4.8672183-6.5856275 4.668916-15.6283395-.4823236-21.9942671zm-25 43.522v-1.626c.5631791.4338852 1.1511768.8345651 1.761 1.2-.571.162-1.161.297-1.761.426zm11 .158c-6.4670477.0037697-12.2997246-3.8880725-14.7787649-9.8611018s-1.1163511-12.8512293 3.4527649-17.4278982c.016-.016.033-.03.049-.047 5.9642315-5.9602674 15.538985-6.2434119 21.845-.646l-2.827 2.827c-3.1568618-2.6784082-7.4729573-3.5369045-11.4144837-2.2704068s-6.9497017 4.4784407-7.9555163 8.4944068c-1.3779061.3007408-2.3602821 1.520656-2.3602821 2.931s.982376 2.6302592 2.3602821 2.931c1.3397915 5.3308904 6.1323253 9.0683991 11.629 9.069.8579173.0014737 1.7133941-.0914181 2.551-.277.8421267 1.2361469 2.469329 1.6578433 3.8058416.9863001 1.3365127-.6715433 1.9693602-2.2288228 1.4801584-3.6423001.7586416-.653961 1.4349393-1.3977541 2.014-2.215 3.1050414-4.4596323 2.817644-10.4510461-.7-14.593l2.827-2.827c4.171558 4.7076887 5.19209 11.4252048 2.6068721 17.1593898s-8.294868 9.4174448-14.5848721 9.4086102zm4-6c0-.5522847.4477153-1 1-1s1 .4477153 1 1-.4477153 1-1 1-1-.4477153-1-1zm2.588-2.535c-.8843509-.5623941-1.9993797-.6179852-2.9352837-.146342-.935904.4716431-1.5546059 1.4009372-1.6287163 2.446342-.6644107.1499655-1.3429037.2287431-2.024.235-4.4988814.0005712-8.4442976-3.0031996-9.641-7.34 1.0062286-.5048287 1.6414679-1.5342345 1.6414679-2.66s-.6352393-2.1551713-1.6414679-2.66c.8974544-3.2600165 3.3827483-5.8449917 6.6049715-6.8698868 3.2222231-1.024895 6.7441796-.3506505 9.3600285 1.7918868l-2.853 2.853c-2.5499139-1.8146732-6.0650555-1.372382-8.0859442 1.0174106s-1.8731155 5.9295674.3399254 8.1426082c2.2130408 2.2130409 5.7528156 2.3608141 8.1426082.3399254s2.8320838-5.5360303 1.0174106-8.0859442l2.853-2.853c2.8275119 3.4512941 3.0222262 8.3595659.477 12.024-.4714958.649893-1.0175561 1.2422694-1.627 1.765zm-17.588-8.465c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1-1-.4477153-1-1 .4477153-1 1-1zm15 1c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4 1.790861-4 4-4c.7118154.0034834 1.4094405.1993989 2.019.567l-2.726 2.726c-.2599566.2510745-.3642126.6228779-.2726972.9725073.0915155.3496295.3645604.6226744.7141899.7141899.3496294.0915154.7214328-.0127406.9725073-.2726972l2.726-2.726c.3676011.6095595.5635166 1.3071846.567 2.019z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4.48 38.815c-.47158266.2872381-.62110421.9023358-.334 1.374.322.531.865 1.377 1.621 2.4.21185849.2877775.56115125.4406696.91630308.4010835.35515182-.0395861.6622067-.2656364.80550002-.593s.10105541-.7063061-.1108031-.9940835c-.713-.969-1.223-1.761-1.524-2.257-.28824164-.4705133-.90311774-.6186384-1.374-.331z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m9.3 45.307c-.39371575.3871784-.39908788 1.0201952-.012 1.414 2.9409484 3.0405687 6.4266755 5.5018801 10.276 7.256.1286361.0564276.2675321.0857047.408.086.4721023.0004918.8802363-.3292553.9789412-.7909242.098705-.4616689-.1389113-.9294776-.5699412-1.1220758-3.6216664-1.6519918-6.9008426-3.969498-9.667-6.832-.3874559-.3934364-1.02047002-.3983609-1.414-.011z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 12c.5522847 0 1-.4477153 1-1v-2c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v2c0 .5522847.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10 29h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 17c.4043959-.0000863.7689341-.2437275.923678-.6173454.1547439-.373618.0692299-.8036603-.216678-1.0896546l-5-5c-.3923789-.37897221-1.0160848-.37355237-1.4018186.0121814-.3857338.3857338-.3911536 1.0094397-.0121814 1.4018186l5 5c.1874927.1875494.4418052.2929434.707.293z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m31.293 11.293c-.3903819.3904999-.3903819 1.0235001 0 1.414l10 10c.3923789.3789722 1.0160848.3735524 1.4018186-.0121814s.3911536-1.0094397.0121814-1.4018186l-10-10c-.3904999-.3903819-1.0235001-.3903819-1.414 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg097Scan);
export default __webpack_public_path__ + "static/media/097-scan.e2c16c641246a30215272b24b2fc7c9d.svg";
export { ForwardRef as ReactComponent };